import React, { type ComponentType } from 'react';
import initial from 'lodash/initial';
import last from 'lodash/last';
import ReposIcon from '@atlaskit/icon/glyph/bitbucket/repos';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { BitbucketIcon } from '@atlaskit/logo';
import type { NavLink, NavigationItem } from '@atlassian/jira-navigation-types/src/types.tsx';

const getLinkParts = (linkId: string): string[] => linkId.split(':')[1].split('.');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SizedBitBucketIcon = (props: any) => <BitbucketIcon {...props} size="small" />;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getIcon = (iconName?: string): ComponentType<any> => {
	switch (iconName) {
		case 'bitbucket':
			return SizedBitBucketIcon;
		case 'github':
		case 'repos':
			// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
			return ReposIcon;
		default:
			// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
			return ShortcutIcon;
	}
};

// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
export const getIdFromLinkId = (linkId: string): string => last(getLinkParts(linkId));

export const getShortcutTypeFromLinkId = (linkId: string): string =>
	initial(getLinkParts(linkId)).join('.');

export const getItemFromLink = (link: NavLink): NavigationItem => {
	const { id: linkId, icon } = link;
	const id = getIdFromLinkId(linkId);
	const shortcutType = getShortcutTypeFromLinkId(linkId);
	const target = link.target || '_blank';
	const Icon = getIcon(icon);

	return {
		type: 'Item',
		id,
		icon,
		legacyId: linkId,
		target,
		shortcutType,
		text: link.name,
		before: Icon,
		href: link.url,
		canEdit: link.canEdit,
		showSync: link.showSync,
		itemType: 'shortcut',
	};
};
